import { Component, input } from '@angular/core';
import { TextInputComponent, textInputImports } from './text-input.component';

@Component({
    selector: 'app-email-input',
    templateUrl: 'text-input.component.html',
    styleUrl: 'text-input.component.scss',
    imports: [textInputImports],
})
export class EmailInputComponent extends TextInputComponent {

    public override label = input<string>('email');

    public override icon = input<string | undefined>('pi-envelope');

}
